/**
 * KAN-1003: контакты поддержки и реквизиты продавца для публичных страниц.
 * Одно место для подвала, соглашения, политики и страницы цен.
 * ЮKassa требует реквизиты продавца на сайте: ИП, ФИО, ИНН, ОГРНИП.
 * Паспортные данные и почтовый (домашний) адрес НЕ публикуются.
 */
import type { LegalInline } from './types';

export const SERVICE_NAME = 'Сметчик';
export const SERVICE_SITE = 'smetchik.ai-doce.ru';
export const LEGAL_EDITION = 'Редакция от 05.11.2026';

export const SUPPORT_EMAIL = 'docentovich@yandex.ru';
export const SUPPORT_PHONE_DISPLAY = '+7 921 393-21-37';
export const SUPPORT_PHONE_TEL = '+79213932137';

export const SELLER = {
  /** Краткое обозначение для подвала. */
  shortName: 'ИП Прозоров Андрей Юрьевич',
  /** Полное обозначение для сторон договора. */
  fullName: 'Индивидуальный предприниматель Прозоров Андрей Юрьевич',
  inn: '601101411301',
  ogrnip: '325784700240201',
  email: SUPPORT_EMAIL,
  phone: SUPPORT_PHONE_DISPLAY,
  /** Номер уведомления в реестре операторов персональных данных Роскомнадзора. */
  rknNotice: '9881395',
} as const;

/** "ИНН ..., ОГРНИП ..." одной строкой. */
export const SELLER_REQUISITES = `ИНН ${SELLER.inn}, ОГРНИП ${SELLER.ogrnip}`;

export const LEGAL_PATHS = {
  terms: '/terms',
  privacy: '/privacy',
  prices: '/prices',
} as const;

export const SUPPORT_EMAIL_LINK: LegalInline = { text: SUPPORT_EMAIL, href: `mailto:${SUPPORT_EMAIL}` };
export const SUPPORT_PHONE_LINK: LegalInline = { text: SUPPORT_PHONE_DISPLAY, href: `tel:${SUPPORT_PHONE_TEL}` };
export const TERMS_LINK: LegalInline = { text: 'Пользовательское соглашение', to: LEGAL_PATHS.terms };
export const PRIVACY_LINK: LegalInline = { text: 'Политика конфиденциальности', to: LEGAL_PATHS.privacy };
export const PRICES_LINK: LegalInline = { text: 'Цены', to: LEGAL_PATHS.prices };
